import { render, staticRenderFns } from "./VideoCard.vue?vue&type=template&id=72d388de&scoped=true"
import script from "./VideoCard.vue?vue&type=script&lang=ts"
export * from "./VideoCard.vue?vue&type=script&lang=ts"
import style0 from "./VideoCard.vue?vue&type=style&index=0&id=72d388de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d388de",
  null
  
)

export default component.exports